<script setup>
import {useSecurityStore} from "@/stores/Security.js";

const securityStore = useSecurityStore();

if (window.localStorage) {
    let localUserString = window.localStorage.getItem("userContext") || "null";
    let localUser = JSON.parse(localUserString);

    if (localUser && securityStore.userContext !== localUser) {
        securityStore.setUserContext(localUser);
        securityStore.setAccessToken(window.localStorage.getItem("accessToken"));
        securityStore.setVersion(window.localStorage.getItem("version"));
        securityStore.setAuthorities(JSON.parse(window.localStorage.getItem("authorities")));

    }
}



</script>

<template>
    <v-app id="app">
        <router-view/>
    </v-app>
</template>

<style lang="scss">
</style>
